<template>
	<div></div>
</template>

<script>
export default {
	name: 'UndeliveredDispatchesToAddToRouteList',
	setup() {},
}
</script>

<style lang="scss" scoped></style>
